import {Fragment, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Redirect, useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Segment} from 'semantic-ui-react';
import moment from 'moment-jalaali';
import Header from './header';
import Footer from './footer';
import SidebarContainer from './sidebar-container';
import ConsultPackageError from './consult-package-error';
import ConsultPackageWarning from './consult-package-warning';
import PackageError from './package-error';
import MobileVerificationMessage from './mobile-verification-message';
import Loader from '../../shared/loader';
import ScrollToTop from '../../shared/scroll-to-top';
import {ANONYMOUS, AUTHENTICATED, INIT, LOADING} from '../../../redux/constants';
import './index.scss';

function MainLayout(props) {
  const [visible, setVisible] = useState(false);
  const {title, description, loginRequired} = props;

  const location = useLocation();
  const currentURL = `${location.pathname}${location.search.replace('&', ';')}`;

  useEffect(() => {
    if (title) document.title = title;
    if (description) document.description = description;
  }, [title, description]);

  if (loginRequired && props.authStatus === ANONYMOUS)
    return (<Redirect to={`/login?next=${currentURL}`}/>);

  return (
    <Fragment>
      <SidebarContainer visible={visible} setVisible={setVisible}>
        <div className='page-container'>
          <Header setVisible={setVisible}/>
          <main>
            {renderMobileVerificationMessage(props)}
            {renderMessages(props)}
            {renderContent(props)}
          </main>
          <Footer/>
        </div>
      </SidebarContainer>
      <ScrollToTop/>
    </Fragment>
  );
}

function renderMessages(props) {
  if (props.authStatus !== AUTHENTICATED) return null;

  const {student} = props;
  if (props.consultPackageRequired && !student['packageCount'])
    return <ConsultPackageError/>;
  if (!student.expireTime)
    return <ConsultPackageError/>;

  const daysToExpire = moment(student.expireTime).diff(moment(), 'days');
  if (daysToExpire < 0)
    return <ConsultPackageError expireTime={student.expireTime}/>;
  if (daysToExpire < 10)
    return <ConsultPackageWarning expireTime={student.expireTime}/>;
}

function renderMobileVerificationMessage(props) {
  if (props.authStatus !== AUTHENTICATED) return null;

  const {student: {user}} = props;
  if (!user) return null;
  if (user.mobileVerified) return null;
  return (
    <MobileVerificationMessage/>
  );
}

function renderContent(props) {
  const {student, authStatus, loginRequired} = props;

  if (loginRequired && [INIT, LOADING].includes(authStatus))
    return (<Segment><Loader/></Segment>);

  // daysToExpire < 0 is better than student['currentConsultPackageCount'] === 0
  if (props.consultPackageRequired) {
    if (!student.expireTime) return null;
    const daysToExpire = moment(student.expireTime).diff(moment(), 'days');
    if (daysToExpire < 0) return null;
  }

  if (props.packageRequired && !student['package'])
    return (<PackageError/>);
  if (!loginRequired || authStatus === AUTHENTICATED)
    return props.children;
}

MainLayout.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  loginRequired: PropTypes.bool.isRequired,
  consultPackageRequired: PropTypes.bool.isRequired,
  packageRequired: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired
};

MainLayout.defaultProps = {
  loginRequired: true,
  consultPackageRequired: true,
  packageRequired: true
};

function mapStateToProps(state) {
  return {
    authStatus: state.auth.status,
    student: state.student.data
  };
}

export default connect(mapStateToProps)(MainLayout);
